import { z } from "@/zod";

export class ValidationError extends Error {
  constructor(
    message: string,
    public readonly errors: z.ZodError,
    public readonly data: unknown,
  ) {
    super(message);
  }
}
